import { Module } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { AuctionState } from './AuctionState'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { DocumentationsData } from './DocumentationsData'
import { VerificationData } from './VerificationData'

export const state: AuctionState = {
  resforNif: '',
  resforCode: '',
  lastWizardStep: 1,
  procesedAuctionA: false,
  notification: {
    notificarA: '',
    movil: '',
    email: '',
    movilValid: false,
    emailValid: false
  },
  personalData: {
    name: '',
    firstSurname: '',
    secondSurname: '',
    nif: '',
    streetType: '',
    streetTypeName: '',
    street: '',
    streetNumber: '',
    block: '',
    floor: '',
    door: '',
    parish: '',
    parishName: '',
    place: '',
    placeName: '',
    postalCode: '',
    province: '',
    provinceName: '',
    county: '',
    countyName: '',
    local: '',
    phone: '',
    fax: '',
    mobile: '',
    email: ''
  },
  docOptionSelected: 0,
  documentationsData: [] as DocumentationsData[],
  verificationData: [] as VerificationData[],
  representationData: {
    name: '',
    firstSurname: '',
    secondSurname: '',
    nif: ''
  },
  procedureData: [],
  statementsData: {
    rexistro: '',
    rexistroLicitadorXeral: false,
    licitadorXeral: '',
    rexistroLicitadorOficial: false,
    licitadorOficial: '',
    discapacidade: false,
    numDiscapacidade: '',
    temporais: false,
    numTemporais: '',
    mulleres: false,
    numMulleres: '',
    option4Selected: [],
    confirm: false
  }
}

const namespaced = true

export const auction: Module<AuctionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
